"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkPreviewHead = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const OpenGraphHead_1 = require("./OpenGraphHead");
const TwitterCardHead_1 = require("./TwitterCardHead");
/**
 *
 */
function LinkPreviewHead({ openGraph, twitter }) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [openGraph && (0, jsx_runtime_1.jsx)(OpenGraphHead_1.OpenGraphHead, { ...openGraph }), twitter && (0, jsx_runtime_1.jsx)(TwitterCardHead_1.TwitterCardHead, { ...twitter })] }));
}
exports.LinkPreviewHead = LinkPreviewHead;
//# sourceMappingURL=LinkPreviewHead.js.map